export enum User {
	UserIndex = 'User::user.index',
	UserShow = 'User::user.show',
	UserCreate = 'User::user.create',
	UserUpdate = 'User::user.update',
	UserDelete = 'User::user.delete',
	UserMe = 'User::user.me',

	AdminIndex = 'User::admin.index',
	AdminShow = 'User::admin.show',
	AdminCreate = 'User::admin.create',
	AdminUpdate = 'User::admin.update',
	AdminDelete = 'User::admin.delete',

	RoleIndex = 'User::role.index',
	RoleShow = 'User::role.show',
	RoleCreate = 'User::role.create',
	RoleUpdate = 'User::role.update',
	RoleDelete = 'User::role.delete',
}
